import Student from '@/api/services/student'

const state = {
    student: null,
    isAuth: false
}

const getters = {
    student(state) {
        return state.student
    },

    isAuth(state) {
        return state.isAuth
    }
}

const mutations = {
    setStudent(state, student) {
        state.student = student
    },

    setIsAuth(state, isAuth) {
        state.isAuth = isAuth
    }
}

const actions = {
    checkLoginState({ commit }) {
        return Student()
            .getStudent()
            .then(data => {
                if (data.data && data.data.name && data.data.name.length > 0) {
                    commit('setStudent', data.data)
                    commit('setIsAuth', true)
                }

                console.log(data)
            })
            .catch(e => {
                console.log(`[Student] Not signed in.`, `Response: ${e.response}`)
            })
    },
    logout({ commit }) {
        return Student()
            .logout()
            .then(response => {
                commit('setStudent', null)
                commit('setIsAuth', false)
                console.log(response)
            })
            .catch(e => {
                console.warn(e.response)
            })
    }
}

export default {
    state,
    getters,
    mutations,
    actions,
    namespaced: true
}